// Shared by the browser consent store and middleware. No browser dependencies.
export const CONSENT_VERSION = 1
export const CONSENT_REQUIRED_COUNTRIES = new Set([
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'IS',
  'LI',
  'NO',
  'GB',
])

export function parseConsentRecord(raw) {
  if (!raw || typeof raw !== 'string') return null
  try {
    // Request cookies may still contain the encoding written by js-cookie.
    const value = JSON.parse(
      raw.startsWith('{') ? raw : decodeURIComponent(raw),
    )
    return value?.version === CONSENT_VERSION &&
      typeof value.analyticsConsent === 'boolean'
      ? value
      : null
  } catch {
    return null
  }
}

// The strict consent switch (ai_app_backend#1717), off by default: NEXT_PUBLIC_STRICT_CONSENT='true' on Vercel, then a
// redeploy, turns it on. With it on, an unknown country ('ZZ' or none) needs consent like an EU/EEA/UK one, and the
// attribution cookies and tokens (pc_entry, pc_ref, the ad networks' and CrakRevenue's ids) are stored only for a
// visitor whose tracking is allowed. Off, everything is exactly as before. Written out in full so Next inlines it.
export function strictConsentOn() {
  return process.env.NEXT_PUBLIC_STRICT_CONSENT === 'true'
}

// `strict`: the switch above, passed by the caller (the middleware reads it itself).
export function trackingAllowedForRequest(
  country,
  consentCookie,
  forceConsent = false,
  strict = false,
) {
  const decision = parseConsentRecord(consentCookie)
  // An explicit withdrawal is respected in every region.
  if (decision) return decision.analyticsConsent
  if (forceConsent) return false
  const code = (country || 'ZZ').toUpperCase()
  if (strict && code === 'ZZ') return false
  return !CONSENT_REQUIRED_COUNTRIES.has(code)
}
